export default [
    "24 24",
     '<path d="M18.9338 2.62875H9.24664C5.79157 2.62875 2.99068 5.42965 2.99068 8.88472V20.9338" fill="none" stroke="var(--ci-primary-color, currentColor)" stroke-width="4.5"/>'
]

